// import React, { useEffect, useMemo, useState } from "react";
// import {
//   Box,
//   Button,
//   Card,
//   CardContent,
//   Container,
//   Divider,
//   MenuItem,
//   Modal,
//   TextField,
//   Typography,
//   Alert,
//   CircularProgress,
// } from "@mui/material";
// import axiosClient from "../../axiosClient";
// import {
//   apiGetServiceIssues,
//   apiCreateServiceIssue,
//   apiAssignServiceIssue,
//   apiScheduleServiceIssue,
// } from "../../api/serviceIssues";

// // ----------------------------
// // Small helpers
// // ----------------------------
// const modalStyle = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: "min(720px, 92vw)",
//   bgcolor: "background.paper",
//   borderRadius: 2,
//   boxShadow: 24,
//   p: 3,
// };

// function safeStr(v) {
//   if (v === null || v === undefined) return "";
//   return String(v);
// }

// function pickTitle(ticket) {
//   // try common field names
//   return (
//     ticket.title ||
//     ticket.subject ||
//     ticket.name ||
//     ticket.issue_title ||
//     `Ticket #${ticket.id}`
//   );
// }

// function pickDescription(ticket) {
//   return ticket.description || ticket.details || ticket.message || "";
// }

// function pickStatus(ticket) {
//   return ticket.status || ticket.state || ticket.ticket_status || "—";
// }

// function pickCreatedAt(ticket) {
//   return (
//     ticket.created_at ||
//     ticket.createdAt ||
//     ticket.created ||
//     ticket.date_created ||
//     ""
//   );
// }

// function pickAssignedTo(ticket) {
//   // depending on serializer shape:
//   // assigned_to could be id, object, or null
//   const a = ticket.assigned_to ?? ticket.assignedTo ?? null;
//   if (!a) return null;

//   if (typeof a === "number") return { id: a, label: `Technician #${a}` };

//   // object shape guesses
//   const id = a.id ?? a.pk ?? null;
//   const label =
//     a.name ||
//     a.full_name ||
//     (a.user
//       ? `${a.user.first_name || ""} ${a.user.last_name || ""}`.trim() ||
//         a.user.username
//       : null) ||
//     a.username ||
//     (id ? `Technician #${id}` : "Assigned");

//   return { id, label };
// }

// // ----------------------------
// // Main Screen
// // ----------------------------
// export default function ServiceIssues() {
//   const [loading, setLoading] = useState(true);
//   const [err, setErr] = useState("");
//   const [tickets, setTickets] = useState([]);

//   const [staffLoading, setStaffLoading] = useState(true);
//   const [staffErr, setStaffErr] = useState("");
//   const [staff, setStaff] = useState([]); // [{id, label}]

//   // create modal
//   const [openCreate, setOpenCreate] = useState(false);
//   const [createTitle, setCreateTitle] = useState("");
//   const [createDesc, setCreateDesc] = useState("");
//   const [createSaving, setCreateSaving] = useState(false);

//   // assign modal
//   const [openAssign, setOpenAssign] = useState(false);
//   const [assignTicket, setAssignTicket] = useState(null);
//   const [assignStaffId, setAssignStaffId] = useState("");
//   const [assignSaving, setAssignSaving] = useState(false);

//   // schedule modal
//   const [openSchedule, setOpenSchedule] = useState(false);
//   const [scheduleTicket, setScheduleTicket] = useState(null);
//   const [scheduleDate, setScheduleDate] = useState(""); // YYYY-MM-DD
//   const [scheduleStart, setScheduleStart] = useState(""); // HH:MM
//   const [scheduleEnd, setScheduleEnd] = useState(""); // HH:MM
//   const [scheduleSaving, setScheduleSaving] = useState(false);

//   const staffMap = useMemo(() => {
//     const m = new Map();
//     staff.forEach((s) => m.set(String(s.id), s.label));
//     return m;
//   }, [staff]);

//   const loadTickets = async () => {
//     setErr("");
//     setLoading(true);
//     try {
//       const res = await apiGetServiceIssues();
//       // backend returns list
//       setTickets(Array.isArray(res.data) ? res.data : []);
//     } catch (e) {
//       setErr(e?.response?.data?.detail || e?.message || "Failed to load tickets");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const loadStaff = async () => {
//     setStaffErr("");
//     setStaffLoading(true);
//     try {
//       /**
//        * Your backend already has: path("print_all_users/", PrintUsers.as_view(), ...)
//        * We reuse it and read "staff_members".
//        */
//       const res = await axiosClient.get("/print_all_users/");
//       const staffMembers = res?.data?.staff_members || [];
//       const normalized = staffMembers.map((t) => {
//         const id = t.id ?? t.pk;
//         const label =
//           t.full_name ||
//           t.name ||
//           (t.user
//             ? `${t.user.first_name || ""} ${t.user.last_name || ""}`.trim() ||
//               t.user.username
//             : null) ||
//           t.username ||
//           (id ? `Technician #${id}` : "Technician");
//         return { id, label };
//       });
//       setStaff(normalized.filter((x) => x.id !== undefined && x.id !== null));
//     } catch (e) {
//       setStaffErr(
//         e?.response?.data?.detail || e?.message || "Failed to load staff list"
//       );
//     } finally {
//       setStaffLoading(false);
//     }
//   };

//   useEffect(() => {
//     loadTickets();
//     loadStaff();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   // ----------------------------
//   // Actions
//   // ----------------------------
//   const onCreate = async () => {
//     setCreateSaving(true);
//     setErr("");
//     try {
//       /**
//        * IMPORTANT:
//        * Ensure these keys match your ServiceIssueSerializer fields.
//        * If your serializer expects: subject/message etc, change payload keys.
//        */
//       const payload = {
//         title: createTitle,
//         description: createDesc,
//       };

//       await apiCreateServiceIssue(payload);
//       setOpenCreate(false);
//       setCreateTitle("");
//       setCreateDesc("");
//       await loadTickets();
//     } catch (e) {
//       setErr(e?.response?.data?.detail || e?.message || "Failed to create ticket");
//     } finally {
//       setCreateSaving(false);
//     }
//   };

//   const openAssignModal = (ticket) => {
//     setAssignTicket(ticket);
//     const assigned = pickAssignedTo(ticket);
//     setAssignStaffId(assigned?.id ? String(assigned.id) : "");
//     setOpenAssign(true);
//   };

//   const onAssign = async () => {
//     if (!assignTicket?.id) return;
//     setAssignSaving(true);
//     setErr("");
//     try {
//       await apiAssignServiceIssue(assignTicket.id, {
//         staff_id: Number(assignStaffId),
//       });
//       setOpenAssign(false);
//       setAssignTicket(null);
//       await loadTickets();
//     } catch (e) {
//       setErr(e?.response?.data?.detail || e?.message || "Failed to assign ticket");
//     } finally {
//       setAssignSaving(false);
//     }
//   };

//   const openScheduleModal = (ticket) => {
//     setScheduleTicket(ticket);
//     setScheduleDate("");
//     setScheduleStart("");
//     setScheduleEnd("");
//     setOpenSchedule(true);
//   };

//   const onSchedule = async () => {
//     if (!scheduleTicket?.id) return;

//     setScheduleSaving(true);
//     setErr("");
//     try {
//       await apiScheduleServiceIssue(scheduleTicket.id, {
//         appointment_date: scheduleDate,
//         appointment_start_time_str: scheduleStart,
//         appointment_finish_time_str: scheduleEnd,
//       });
//       setOpenSchedule(false);
//       setScheduleTicket(null);
//       await loadTickets();
//     } catch (e) {
//       setErr(
//         e?.response?.data?.detail ||
//           e?.message ||
//           "Failed to schedule appointment"
//       );
//     } finally {
//       setScheduleSaving(false);
//     }
//   };

//   // ----------------------------
//   // UI
//   // ----------------------------
//   return (
//     <Container maxWidth="lg" sx={{ mt: 3, mb: 6 }}>
//       <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
//         <Typography variant="h5" fontWeight={700}>
//           Service Issues (Tickets)
//         </Typography>

//         <Box display="flex" gap={1}>
//           <Button variant="outlined" onClick={() => { loadTickets(); loadStaff(); }}>
//             Refresh
//           </Button>
//           <Button variant="contained" onClick={() => setOpenCreate(true)}>
//             New Ticket
//           </Button>
//         </Box>
//       </Box>

//       {(err || staffErr) && (
//         <Box mb={2}>
//           {err && <Alert severity="error" sx={{ mb: staffErr ? 1 : 0 }}>{err}</Alert>}
//           {staffErr && <Alert severity="warning">{staffErr}</Alert>}
//         </Box>
//       )}

//       <Card>
//         <CardContent>
//           {(loading || staffLoading) && (
//             <Box display="flex" alignItems="center" gap={2} mb={2}>
//               <CircularProgress size={22} />
//               <Typography variant="body2">
//                 Loading {loading ? "tickets" : "staff"}...
//               </Typography>
//             </Box>
//           )}

//           {!loading && tickets.length === 0 && (
//             <Alert severity="info">No tickets found.</Alert>
//           )}

//           {!loading && tickets.length > 0 && (
//             <Box display="flex" flexDirection="column" gap={2}>
//               {tickets.map((t) => {
//                 const assigned = pickAssignedTo(t);
//                 const assignedLabel =
//                   assigned?.id && staffMap.get(String(assigned.id))
//                     ? staffMap.get(String(assigned.id))
//                     : assigned?.label || "Unassigned";

//                 return (
//                   <Box
//                     key={t.id}
//                     sx={{
//                       border: "1px solid rgba(0,0,0,0.10)",
//                       borderRadius: 2,
//                       p: 2,
//                     }}
//                   >
//                     <Box
//                       display="flex"
//                       justifyContent="space-between"
//                       alignItems="flex-start"
//                       gap={2}
//                     >
//                       <Box>
//                         <Typography variant="h6" fontWeight={700}>
//                           {pickTitle(t)}
//                         </Typography>
//                         <Typography variant="body2" sx={{ opacity: 0.8 }}>
//                           {pickDescription(t) ? pickDescription(t) : "—"}
//                         </Typography>

//                         <Box mt={1} display="flex" gap={2} flexWrap="wrap">
//                           <Typography variant="caption">
//                             <b>ID:</b> {safeStr(t.id)}
//                           </Typography>
//                           <Typography variant="caption">
//                             <b>Status:</b> {safeStr(pickStatus(t))}
//                           </Typography>
//                           <Typography variant="caption">
//                             <b>Created:</b> {safeStr(pickCreatedAt(t))}
//                           </Typography>
//                           <Typography variant="caption">
//                             <b>Assigned:</b> {safeStr(assignedLabel)}
//                           </Typography>
//                         </Box>
//                       </Box>

//                       <Box display="flex" gap={1} flexWrap="wrap">
//                         <Button
//                           size="small"
//                           variant="outlined"
//                           onClick={() => openAssignModal(t)}
//                         >
//                           Assign
//                         </Button>

//                         <Button
//                           size="small"
//                           variant="contained"
//                           onClick={() => openScheduleModal(t)}
//                           disabled={!assigned?.id}
//                         >
//                           Schedule
//                         </Button>
//                       </Box>
//                     </Box>

//                     {!assigned?.id && (
//                       <Typography variant="caption" sx={{ opacity: 0.7 }}>
//                         * Assign a technician first to enable scheduling.
//                       </Typography>
//                     )}
//                   </Box>
//                 );
//               })}
//             </Box>
//           )}
//         </CardContent>
//       </Card>

//       {/* ----------------------------
//           CREATE MODAL
//       ---------------------------- */}
//       <Modal open={openCreate} onClose={() => !createSaving && setOpenCreate(false)}>
//         <Box sx={modalStyle}>
//           <Typography variant="h6" fontWeight={700} mb={1}>
//             Create Ticket
//           </Typography>
//           <Divider sx={{ mb: 2 }} />

//           <Box display="flex" flexDirection="column" gap={2}>
//             <TextField
//               label="Title"
//               value={createTitle}
//               onChange={(e) => setCreateTitle(e.target.value)}
//               fullWidth
//             />
//             <TextField
//               label="Description"
//               value={createDesc}
//               onChange={(e) => setCreateDesc(e.target.value)}
//               fullWidth
//               multiline
//               minRows={4}
//             />

//             <Box display="flex" gap={1} justifyContent="flex-end">
//               <Button
//                 variant="outlined"
//                 onClick={() => setOpenCreate(false)}
//                 disabled={createSaving}
//               >
//                 Cancel
//               </Button>
//               <Button
//                 variant="contained"
//                 onClick={onCreate}
//                 disabled={createSaving || !createTitle.trim()}
//               >
//                 {createSaving ? "Saving..." : "Create"}
//               </Button>
//             </Box>

//             <Alert severity="info">
//               If your backend expects different field names (e.g. <b>subject</b> instead of
//               <b> title</b>), tell me your serializer fields and I’ll adjust instantly.
//             </Alert>
//           </Box>
//         </Box>
//       </Modal>

//       {/* ----------------------------
//           ASSIGN MODAL
//       ---------------------------- */}
//       <Modal open={openAssign} onClose={() => !assignSaving && setOpenAssign(false)}>
//         <Box sx={modalStyle}>
//           <Typography variant="h6" fontWeight={700} mb={1}>
//             Assign Technician
//           </Typography>
//           <Divider sx={{ mb: 2 }} />

//           <Typography variant="body2" sx={{ mb: 1, opacity: 0.8 }}>
//             Ticket: <b>{assignTicket ? pickTitle(assignTicket) : ""}</b>
//           </Typography>

//           <TextField
//             select
//             label="Technician"
//             value={assignStaffId}
//             onChange={(e) => setAssignStaffId(e.target.value)}
//             fullWidth
//             disabled={staffLoading || assignSaving}
//           >
//             <MenuItem value="">Unassigned</MenuItem>
//             {staff.map((s) => (
//               <MenuItem key={s.id} value={String(s.id)}>
//                 {s.label}
//               </MenuItem>
//             ))}
//           </TextField>

//           <Box mt={2} display="flex" gap={1} justifyContent="flex-end">
//             <Button
//               variant="outlined"
//               onClick={() => setOpenAssign(false)}
//               disabled={assignSaving}
//             >
//               Cancel
//             </Button>
//             <Button
//               variant="contained"
//               onClick={onAssign}
//               disabled={assignSaving || !assignStaffId}
//             >
//               {assignSaving ? "Saving..." : "Assign"}
//             </Button>
//           </Box>
//         </Box>
//       </Modal>

//       {/* ----------------------------
//           SCHEDULE MODAL
//       ---------------------------- */}
//       <Modal
//         open={openSchedule}
//         onClose={() => !scheduleSaving && setOpenSchedule(false)}
//       >
//         <Box sx={modalStyle}>
//           <Typography variant="h6" fontWeight={700} mb={1}>
//             Schedule Appointment
//           </Typography>
//           <Divider sx={{ mb: 2 }} />

//           <Typography variant="body2" sx={{ mb: 2, opacity: 0.8 }}>
//             Ticket: <b>{scheduleTicket ? pickTitle(scheduleTicket) : ""}</b>
//           </Typography>

//           <Box display="flex" flexDirection="column" gap={2}>
//             <TextField
//               label="Date"
//               type="date"
//               value={scheduleDate}
//               onChange={(e) => setScheduleDate(e.target.value)}
//               InputLabelProps={{ shrink: true }}
//               fullWidth
//               disabled={scheduleSaving}
//             />

//             <Box display="flex" gap={2} flexWrap="wrap">
//               <TextField
//                 label="Start Time"
//                 type="time"
//                 value={scheduleStart}
//                 onChange={(e) => setScheduleStart(e.target.value)}
//                 InputLabelProps={{ shrink: true }}
//                 fullWidth
//                 disabled={scheduleSaving}
//                 sx={{ flex: 1, minWidth: 220 }}
//               />
//               <TextField
//                 label="End Time"
//                 type="time"
//                 value={scheduleEnd}
//                 onChange={(e) => setScheduleEnd(e.target.value)}
//                 InputLabelProps={{ shrink: true }}
//                 fullWidth
//                 disabled={scheduleSaving}
//                 sx={{ flex: 1, minWidth: 220 }}
//               />
//             </Box>

//             <Box display="flex" gap={1} justifyContent="flex-end">
//               <Button
//                 variant="outlined"
//                 onClick={() => setOpenSchedule(false)}
//                 disabled={scheduleSaving}
//               >
//                 Cancel
//               </Button>
//               <Button
//                 variant="contained"
//                 onClick={onSchedule}
//                 disabled={
//                   scheduleSaving ||
//                   !scheduleDate ||
//                   !scheduleStart ||
//                   !scheduleEnd
//                 }
//               >
//                 {scheduleSaving ? "Saving..." : "Create Appointment"}
//               </Button>
//             </Box>

//             <Alert severity="info">
//               Backend expects:
//               <b> appointment_date</b>, <b>appointment_start_time_str</b>,
//               <b> appointment_finish_time_str</b>.
//             </Alert>
//           </Box>
//         </Box>
//       </Modal>
//     </Container>
//   );
// }

import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  TextField,
  Button,
  Divider,
  CircularProgress,
  Alert,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";

// import axiosClient from "../../axiosClient";
// import {
//   apiGetServiceIssues,
//   apiCreateServiceIssue,
//   apiAssignServiceIssue,
//   apiScheduleServiceIssue,
// } from "../../api/serviceIssues";

import axiosClient from "../axiosClient";
import {
  apiGetServiceIssues,
  apiCreateServiceIssue,
  apiAssignServiceIssue,
  apiScheduleServiceIssue,
//   apiGetServiceIssueById,
} from "../api/serviceIssues";


const ServiceIssues = () => {
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");
  const [items, setItems] = useState([]);

  // create ticket form
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  // staff list for assign
  const [staffLoading, setStaffLoading] = useState(false);
  const [staff, setStaff] = useState([]);

  // dialogs
  const [assignOpen, setAssignOpen] = useState(false);
  const [scheduleOpen, setScheduleOpen] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);

  // assign
  const [selectedStaffId, setSelectedStaffId] = useState("");

  // schedule
  const [appointmentDate, setAppointmentDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [finishTime, setFinishTime] = useState("");

  const refresh = async () => {
    setLoading(true);
    setErr("");
    try {
      const res = await apiGetServiceIssues();
      setItems(res.data || []);
    } catch (e) {
      setErr(e?.response?.data?.detail || "Failed to load service issues");
    } finally {
      setLoading(false);
    }
  };

  const loadStaff = async () => {
    setStaffLoading(true);
    try {
      // You already have users endpoints in backend.
      // This endpoint is common in your system (SearchUsers/PrintUsers etc).
      // Adjust if your endpoint differs:
      const res = await axiosClient.get("/users/print/?role=STAFF");
      // fallback if API returns different shape:
      const staffList =
        res.data?.staff_members ||
        res.data?.results?.staff_members ||
        res.data?.staff ||
        [];
      setStaff(staffList);
    } catch (e) {
      // if your staff endpoint is different, you will see this error
      console.log("Failed to load staff list", e);
      setStaff([]);
    } finally {
      setStaffLoading(false);
    }
  };

  useEffect(() => {
    refresh();
    loadStaff();
  }, []);

  const onCreate = async () => {
    setErr("");
    if (!title.trim()) {
      setErr("Title is required");
      return;
    }
    try {
      await apiCreateServiceIssue({ title, description });
      setTitle("");
      setDescription("");
      await refresh();
    } catch (e) {
      setErr(e?.response?.data?.detail || "Failed to create ticket");
    }
  };

  const openAssign = (ticket) => {
    setSelectedTicket(ticket);
    setSelectedStaffId("");
    setAssignOpen(true);
  };

  const confirmAssign = async () => {
    if (!selectedTicket) return;
    if (!selectedStaffId) {
      setErr("Please select staff");
      return;
    }
    setErr("");
    try {
      await apiAssignServiceIssue(selectedTicket.id, { staff_id: Number(selectedStaffId) });
      setAssignOpen(false);
      setSelectedTicket(null);
      await refresh();
    } catch (e) {
      setErr(e?.response?.data?.detail || "Failed to assign ticket");
    }
  };

  const openSchedule = (ticket) => {
    setSelectedTicket(ticket);
    setAppointmentDate("");
    setStartTime("");
    setFinishTime("");
    setScheduleOpen(true);
  };

  const confirmSchedule = async () => {
    if (!selectedTicket) return;

    if (!appointmentDate || !startTime || !finishTime) {
      setErr("Please fill appointment date/start/end");
      return;
    }

    setErr("");
    try {
      await apiScheduleServiceIssue(selectedTicket.id, {
        appointment_date: appointmentDate,
        appointment_start_time_str: startTime,
        appointment_finish_time_str: finishTime,
      });
      setScheduleOpen(false);
      setSelectedTicket(null);
      await refresh();
    } catch (e) {
      setErr(e?.response?.data?.detail || "Failed to schedule appointment");
    }
  };

  const staffLabel = useMemo(() => {
    const m = new Map();
    (staff || []).forEach((s) => {
      // depending on serializer, fields might differ
      const id = s?.id || s?.pk;
      const name =
        s?.user?.first_name && s?.user?.last_name
          ? `${s.user.first_name} ${s.user.last_name}`
          : s?.user?.username || s?.username || `Staff ${id}`;
      if (id != null) m.set(Number(id), name);
    });
    return m;
  }, [staff]);

  return (
    <Box sx={{ maxWidth: 1200, mx: "auto" }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Service Issues
      </Typography>

      {err && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {String(err)}
        </Alert>
      )}

      <Paper sx={{ p: 2, mb: 2 }}>
        <Typography variant="subtitle1" sx={{ mb: 1 }}>
          Create new ticket
        </Typography>

        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
          <TextField
            label="Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            size="small"
            sx={{ minWidth: 260, flex: 1 }}
          />
          <TextField
            label="Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            size="small"
            sx={{ minWidth: 260, flex: 2 }}
          />
          <Button variant="contained" onClick={onCreate}>
            Create
          </Button>
        </Box>
      </Paper>

      <Paper sx={{ p: 2 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
          <Typography variant="subtitle1">Tickets</Typography>
          <Button variant="outlined" onClick={refresh} disabled={loading}>
            Refresh
          </Button>
        </Box>

        <Divider sx={{ mb: 2 }} />

        {loading ? (
          <Box sx={{ py: 6, display: "flex", justifyContent: "center" }}>
            <CircularProgress />
          </Box>
        ) : (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Title</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Assigned</TableCell>
                <TableCell>Status</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {(items || []).map((t) => {
                const assignedId = t?.assigned_to?.id || t?.assigned_to;
                const assignedName =
                  t?.assigned_to?.user?.first_name && t?.assigned_to?.user?.last_name
                    ? `${t.assigned_to.user.first_name} ${t.assigned_to.user.last_name}`
                    : staffLabel.get(Number(assignedId)) || "-";

                const status = t?.status || "OPEN";

                return (
                  <TableRow key={t.id}>
                    <TableCell>{t.id}</TableCell>
                    <TableCell>{t.title || "-"}</TableCell>
                    <TableCell sx={{ maxWidth: 380, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                      {t.description || "-"}
                    </TableCell>
                    <TableCell>{assignedName}</TableCell>
                    <TableCell>
                      <Chip size="small" label={status} />
                    </TableCell>
                    <TableCell align="right">
                      <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
                        <Button size="small" variant="outlined" onClick={() => openAssign(t)}>
                          Assign
                        </Button>
                        <Button size="small" variant="contained" onClick={() => openSchedule(t)} disabled={!assignedId}>
                          Schedule
                        </Button>
                      </Box>
                    </TableCell>
                  </TableRow>
                );
              })}

              {(!items || items.length === 0) && (
                <TableRow>
                  <TableCell colSpan={6}>
                    <Typography variant="body2" sx={{ py: 2, textAlign: "center" }}>
                      No tickets found
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        )}
      </Paper>

      {/* Assign dialog */}
      <Dialog open={assignOpen} onClose={() => setAssignOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>Assign ticket</DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Ticket: #{selectedTicket?.id} {selectedTicket?.title ? `— ${selectedTicket.title}` : ""}
          </Typography>

          <FormControl fullWidth size="small" disabled={staffLoading}>
            <InputLabel id="staff-select-label">Staff</InputLabel>
            <Select
              labelId="staff-select-label"
              label="Staff"
              value={selectedStaffId}
              onChange={(e) => setSelectedStaffId(e.target.value)}
            >
              {(staff || []).map((s) => {
                const id = s?.id || s?.pk;
                const name =
                  s?.user?.first_name && s?.user?.last_name
                    ? `${s.user.first_name} ${s.user.last_name}`
                    : s?.user?.username || s?.username || `Staff ${id}`;
                return (
                  <MenuItem key={id} value={String(id)}>
                    {name}
                  </MenuItem>
                );
              })}
              {(staff || []).length === 0 && <MenuItem value="">No staff found</MenuItem>}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAssignOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={confirmAssign}>
            Assign
          </Button>
        </DialogActions>
      </Dialog>

      {/* Schedule dialog */}
      <Dialog open={scheduleOpen} onClose={() => setScheduleOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>Schedule appointment</DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Ticket: #{selectedTicket?.id} {selectedTicket?.title ? `— ${selectedTicket.title}` : ""}
          </Typography>

          <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
            <TextField
              label="Date"
              type="date"
              size="small"
              value={appointmentDate}
              onChange={(e) => setAppointmentDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              sx={{ minWidth: 200 }}
            />
            <TextField
              label="Start"
              type="time"
              size="small"
              value={startTime}
              onChange={(e) => setStartTime(e.target.value)}
              InputLabelProps={{ shrink: true }}
              sx={{ minWidth: 160 }}
            />
            <TextField
              label="End"
              type="time"
              size="small"
              value={finishTime}
              onChange={(e) => setFinishTime(e.target.value)}
              InputLabelProps={{ shrink: true }}
              sx={{ minWidth: 160 }}
            />
          </Box>

          <Typography variant="caption" sx={{ display: "block", mt: 2 }}>
            * Schedule is enabled only after assignment (button disabled otherwise).
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setScheduleOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={confirmSchedule}>
            Create appointment
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ServiceIssues;